var map = {
	"./__tests__/lti.resourceImported.test.js": [
		"LFe7",
		4165
	],
	"./__tests__/lti.screenReaderAlert.test.js": [
		"0Guc",
		4166
	],
	"./__tests__/lti.showAlert.test.js": [
		"+y7l",
		4167
	],
	"./__tests__/org.imsglobal.lti.get_data.test.js": [
		"CXUv",
		4152
	],
	"./__tests__/org.imsglobal.lti.put_data.test.js": [
		"mElt",
		4153
	],
	"./__tests__/requestFullWindowLaunch.test.js": [
		"o6ta",
		4168
	],
	"./lti.enableScrollEvents.js": [
		"HVU3",
		4225
	],
	"./lti.fetchWindowSize.js": [
		"OANa",
		4226
	],
	"./lti.frameResize.js": [
		"bSyB",
		4154
	],
	"./lti.removeUnloadMessage.js": [
		"tjuu",
		4169
	],
	"./lti.resourceImported.js": [
		"FC2N",
		4227
	],
	"./lti.screenReaderAlert.js": [
		"YYEg",
		4228
	],
	"./lti.scrollToTop.js": [
		"W/R1",
		4229
	],
	"./lti.setUnloadMessage.js": [
		"6fDN",
		4170
	],
	"./lti.showAlert.js": [
		"onLg",
		4230
	],
	"./lti.showModuleNavigation.js": [
		"NSTA",
		4231
	],
	"./org.imsglobal.lti.capabilities.js": [
		"zPPZ",
		4232
	],
	"./org.imsglobal.lti.get_data.js": [
		"lH2A",
		4163
	],
	"./org.imsglobal.lti.put_data.js": [
		"hugc",
		4164
	],
	"./requestFullWindowLaunch.js": [
		"8IHO",
		4233
	],
	"./toggleCourseNavigationMenu.js": [
		"ECMy",
		4234
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "G4i8";
module.exports = webpackAsyncContext;